import React from 'react';
import FeatureCards from "../../../../components/FeatureCards/FeatureCards";
import CTA from "../../../../components/Constant/cta/CTA";
import TimelineSection from "../../../../components/TimelineSection/TimelineSection";
import WhySection from "../../../../components/WhySection/WhySection";
import IntroSection from "../../../../components/IntroSection/IntroSection";
import FAQList from "../../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../../../components/InfoBlocks/InfoBlocks";
import ServiceCards from "../../../../components/ServiceCards/ServiceCards";
import SEO from "../../../../utils/SEO";

export default function AssetManagementLicenseWesternSahara() {

    return (
        <main className='main'>
            <SEO
                title=""
                description=""
                keywords=""
                url="/asset-management-license-western-sahara"
            />
            <IntroSection
                title="Asset Management License – Western Sahara"
                subtitle="Manage Global Investments with CRA Licensing"
                description="The Capital Regulatory Authority (CRA) of Western Sahara provides one of the most flexible and affordable frameworks for Asset Management Licenses. With no statutory capital requirements and a fast-track approval process, CRA is the perfect jurisdiction for launching investment firms, fund managers, wealth managers, and family offices."
                badges={[
                    "Investment Fund Management",
                    "Portfolio Management",
                    "Wealth & Family Office Services"
                ]}
                buttonText="Request an Asset Management Proposal →"
                buttonLink="/quote"
                imageSrc={require("../../../../assets/images/services/Asset Management License – Western Sahara-hero.png")}
                imageAlt="Western Sahara Asset Management"
            />

            <section className='section'>
                <div className="container">
                    <WhySection
                        title='Why Choose Western Sahara?'
                        blocks={
                            [
                                {
                                    items:
                                        [
                                            {
                                                title: "No Capital Requirement",
                                                text: "Unlike EU or Tier-1 regulators."
                                            },
                                            {
                                                title: "Fast Licensing",
                                                text: "Approval in 1–2 weeks."
                                            },
                                            {
                                                title: "Operate Globally",
                                                text: "Recognized in offshore financial markets."
                                            },
                                            {
                                                title: "Multi-Sector Flexibility",
                                                text: "Combine with brokerage, trust, or fintech modules."
                                            },
                                            {
                                                title: "Banking Access",
                                                text: "Easier onboarding with EMIs & custodians."
                                            }
                                        ]
                                }
                            ]
                        }
                    />

                    <InfoBlocks
                        title="What the License Covers"
                        blocks={[
                            {
                                title: "CRA Asset Management License",
                                items: [
                                    { text: "Manage collective investment schemes (fund management)." },
                                    { text: "Provide portfolio & wealth management services." },
                                    { text: "Operate family offices for HNWIs and UHNWI clients." },
                                    { text: "Offer investment advisory services." },
                                    { text: "Establish private equity & venture capital structures." },
                                    { text: "Combine with forex, brokerage, or crypto modules for hybrid models." }
                                ]
                            }
                        ]}
                    />

                    <ServiceCards
                        title='Benefits of CRA Asset Management License'
                        services={
                            [
                                {
                                    title: "Global Reach",
                                    text: "Attract international investors."
                                },
                                {
                                    title: "Regulatory Compliance",
                                    text: "AML/KYC aligned with FATF standards."
                                },
                                {
                                    title: "Flexible Structures",
                                    text: "Manage funds, portfolios, or private wealth."
                                },
                                {
                                    title: "Affordable",
                                    text: "No minimum capital and lower fees than EU regulators."
                                },
                                {
                                    title: "Investor Confidence",
                                    text: "CRA licensing adds credibility to your firm."
                                }
                            ]
                        }
                    />

                    <FeatureCards
                        title='Licensing Process'
                        features={
                            [
                                {
                                    title: "Consultation & Structuring",
                                    text: "Define fund or management model."
                                },
                                {
                                    title: "Company Incorporation",
                                    text: "Register entity under CRA jurisdiction."
                                },
                                {
                                    title: "Compliance Framework",
                                    text: "Prepare AML/KYC manuals, risk management policies, and business plan."
                                },
                                {
                                    title: "Application Filing",
                                    text: "Offshore Advisory submits application to CRA."
                                },
                                {
                                    title: "Approval & License Grant",
                                    text: "Typically granted within 1–2 weeks."
                                }
                            ]
                        }
                    />

                    <TimelineSection
                        title='Timeline & Costs'
                        items={[
                            {
                                name: "Timeline",
                                duration: "1–2 weeks",
                            },
                            {
                                name: "Setup Costs",
                                description: "From USD 16,000+",
                            },
                            {
                                name: "Capital Requirement",
                                description: "❌ None",
                            },
                            {
                                name: "Annual Costs",
                                description: "Annual Renewal Fees: competitive vs Mauritius, Malta, or Luxembourg",
                            },
                        ]}
                    />


                    <DetailsSection
                        title='Why Offshore Advisory?'
                        items={
                            [
                                {
                                    text: "Licensed CRA agent with asset management expertise"
                                },
                                {
                                    text: "End-to-end service: structuring, compliance, licensing, and banking"
                                },
                                {
                                    text: "Access to fund administrators, custodians, and PSPs"
                                },
                                {
                                    text: "Support for family office and HNWI-focused models"
                                },
                                {
                                    text: "Hybrid solutions combining fund + forex + crypto if needed"
                                }
                            ]
                        }
                    />

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />

                    <CTA
                        title="Ready to manage investments globally?"
                        description="With no capital requirements and fast approvals, CRA in Western Sahara is the ideal jurisdiction for asset management and fund services."
                        buttonText="Book a CRA Asset Management Consultation →"
                        buttonLink="/quote"
                    />
                </div>
            </section>
        </main>
    );
};

const testimonialsData = [
    {
        quote: "Offshore Advisory helped us obtain an Asset Management License in Western Sahara. Fast, cost-efficient, and no capital required.",
        author: "Daniel P.",
        role: "Fund Manager"
    },
    {
        quote: "We launched a family office under CRA licensing with Offshore Advisory’s support. Smooth process from start to finish.",
        author: "Sophia L.",
        role: "Wealth Manager"
    }
];

const faqData = [
    {
        question: "Is there a capital requirement for asset management in Western Sahara?",
        content: [
            { type: "answer", text: "No — CRA requires no minimum capital, unlike Mauritius or EU regulators." },
        ],
    },
    {
        question: "Can I manage funds for international clients?",
        content: [
            { type: "answer", text: "Yes — CRA licenses are intended for international operations." },
        ],
    },
    {
        question: "How long does licensing take?",
        content: [
            { type: "answer", text: "Usually 1–2 weeks, depending on documentation." },
        ],
    },
    {
        question: "Can I combine asset management with other services?",
        content: [
            { type: "answer", text: "Yes — CRA allows combined licenses (e.g., brokerage + asset management)." },
        ],
    },
    {
        question: "Will this license help me access banking?",
        content: [
            { type: "answer", text: "Yes — Offshore Advisory assists with EMI/custodian accounts for fund operations." },
        ],
    },
];
